export default "__VITE_PUBLIC_ASSET__84a79ad5__"